import { Data } from "@cirrus/fe-lib"

import { pick } from "ramda"
import { cx } from "ramda-extension/es"
import { createElement as h } from "react"
import T from "prop-types"
import TextAreaAutoSize from "react-textarea-autosize"

import styles from "./inputs.less"

export const Textarea = ({
  className,
  disabled,
  notValid,
  onChange,
  scrollable = false,
  ...props
}) =>
  h(
    TextAreaAutoSize,
    Data.merged(
      {
        className: cx(styles.textarea, className, {
          disabled,
          [styles.notValid]: notValid,
          [styles.scrollable]: scrollable,
        }),

        disabled,
        onChange: (event) => onChange && onChange(event, event.target.value),
      },

      pick(
        ["autoFocus", "cols", "name", "onBlur", "placeholder", "readOnly", "rows", "value"],
        props,
      ),
    ),
  )

Textarea.propTypes = {
  value: T.string,
  disabled: T.bool,
  autoFocus: T.bool,
  placeholder: T.string,
  className: T.string,
  notValid: T.bool,
  onChange: T.func,
  onBlur: T.func,
  scrollable: T.bool,
}
